// extracted by mini-css-extract-plugin
export default {"meta":"IOOn8","title":"zTLk5","alert_title":"P1pF7","description":"mVCMK"};